import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

/**
 * @typedef {Object} MerchantFeatures
 * @property {boolean} allows_refunds
 * @property {string} max_duration_for_refund
 * @property {string} refund_reference_date
 * @property {boolean} shipping_included
 * @property {string} issue_refund_at_status
 * @property {boolean} allows_exchanges
 * @property {string} max_duration_for_exchange
 * @property {string} exchange_reference_date
 * @property {string[]} allowed_exchange_methods
 * @property {string[]} allowed_same_product_exchange_comparison_methods
 * @property {boolean} exchange_orders_automatic_creation
 * @property {boolean} exchange_orders_send_provider_notification
 * @property {boolean} allows_instant_exchanges
 * @property {boolean} instant_exchange_orders_automatic_creation
 * @property {boolean} instant_exchange_orders_send_provider_notification
 * @property {string} issue_exchange_at_status
 * @property {string} exchange_error_resolution
 * @property {(null|string)[]} available_issue_refund_status
 * @property {string[]} available_issue_exchange_status
 * @property {boolean} shipments_email_editor_enabled
 * @property {string[]} enabled_portals
 * @property {boolean} allows_instant_transactions
 */

/**
 * @param {{merchantId: string|number, doInitialRequest?: boolean }} params
 * @returns {{
 *  merchantFeatures: MerchantFeatures|undefined,
 *  refetchMerchantFeatures: () => Promise<MerchantFeatures>,
 *  fetchingMerchantFeatures: boolean
 * }}
 */

const useMerchantFeatures = ({ merchantId, doInitialRequest = true }) => {
  const {
    data: merchantFeatures,
    fetchData: refetchMerchantFeatures,
    loading: fetchingMerchantFeatures,
  } = useFetch(() => configurationServices.getMerchantPreferences({ merchantId }), {
    doInitialRequest,
  })

  return { merchantFeatures, refetchMerchantFeatures, fetchingMerchantFeatures }
}

export default useMerchantFeatures
